// extracted by mini-css-extract-plugin
export default {"loading_btn":"styles_loading_btn__Dzl2v","progress":"styles_progress__u-ekf"};